import { onDocumentLoaded } from "../utils/on-document-loaded.js";
import { tabs } from "../modules/smart-business/tabs.js";

onDocumentLoaded(() => {
    tabs();
});